module.exports = __webpack_public_path__ + "assets/img/00027.da175830.png";